import { useMerchant } from "@/hooks/useMerchant";

export function useBuildingManagementEnabled(): boolean {
  const { merchant } = useMerchant();
  return !!merchant?.payoutsConfig?.buildingManagementEnabled;
}
